<template>
  <div class="index">
    <van-nav-bar
        title="查询用户"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

<!--    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
            v-model="c_code"
            required
            label="户号"
            placeholder="请输入用户号"
        />
        <van-field
            v-model="c_name"
            required
            label="户名"
            placeholder="请输入户名"
        />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提  交
        </van-button>
      </div>
    </van-form>-->

    <van-form @submit="onSubmit">
      <van-field
          v-model="c_code"
          name="户号"
          label="户号"
          placeholder="户号"
          :rules="[{ required: true, message: '请输入户号' }]"
      />
      <van-field
          v-model="c_name"
          name="户名"
          label="户名"
          placeholder="户名"
          :rules="[{ required: true, message: '请填写户名' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提 交</van-button>
      </div>
    </van-form>



  </div>
</template>
<script>
//import { Toast } from 'vant';
import API from './../api/index'
export default {
  name: 'page_searchcust',
  data() {
    return {
      c_code: '',
      c_name: '',
    };
  },
  methods: {
    onSubmit() {
      this.$cookie.set('c_code',this.c_code, { expires: '360m' });
      this.$cookie.set('c_name',this.c_name,  { expires: '360m' });
      this.$http.get(API.LookCustforBind,{
        params: {
          c_code:this.c_code,
          c_name:this.c_name
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code === 0) {
              this.$cookie.set('myAddress',res.myAddress,  { expires: '360m' });
              this.$cookie.set('myPhone',res.myPhone,  { expires: '360m' });
              this.$cookie.set('CID',res.myID,  { expires: '360m' });
              this.$router.push('/bind');
            }
          })
    },
    onClickLeft(){
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
</style>